import EmptyWrap from "@/components/Gui/EmptyWrap";

export default [
    {
        path: 'subscription-chain',
        component: EmptyWrap,
        children: [
            {
                path: '',
                name: 'subscription-chain.list',
                component: require('@/views/SubscriptionChain/SubscriptionChainList').default,
            },
            {
                path: ':id',
                component: require('@/views/SubscriptionChain/Card/WrapBlock').default,
                children: [
                    {
                        path: 'detail',
                        name: 'subscription-chain.detail',
                        component: require('@/views/SubscriptionChain/Card/SubscribeTab').default,
                    },
                ]
            },
        ]
    },
]
